module.exports = __webpack_public_path__ + "static/media/blogcake_image1.d3fe3fd7.jpg";